import { render, staticRenderFns } from "./dr-process-item.vue?vue&type=template&id=9f6dc352"
import script from "./dr-process-item.vue?vue&type=script&lang=js"
export * from "./dr-process-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports